<section role="main" class="main-section">
  <router-outlet></router-outlet>
</section>